export default {"src":"/_next/static/media/cooking.dbcf4456.svg","height":28,"width":29,"blurWidth":0,"blurHeight":0};